import React, { FunctionComponent, useState } from 'react'

// The Copilot Studio support chat, as it was before the assistant panel
// replaced it in this slot.
//
// It is here because "the assistant is off" and "there is no chat at all" are
// different things, and the panel used to conflate them: WebChat returned null
// for mode 'off', and since this component's markup had been replaced rather
// than moved aside, an environment with the assistant switched off served no
// chat whatsoever. That is not only the pre-launch window -- an account that
// opts out of the assistant resolves to 'off' too, and should not lose support
// chat as a side effect of declining a different feature.
//
// Class names are namespaced away from `web-chat-*`: the panel kept those
// selectors and restyled them, so reusing them here would inherit the panel's
// geometry.
// tslint:disable-next-line:max-line-length
const EMBED_URL =
  'https://copilotstudio.microsoft.com' +
  '/environments/3de313c4-aa41-efab-b917-63aa4f8e881d/bots/copilots_header_107aa/webchat?__version__=2'

const SupportChat: FunctionComponent = () => {
  // Two pieces of state, not one: `isOpen` mounts the iframe the first time the
  // launcher is clicked and never unmounts it, while `isHidden` only toggles
  // display. Unmounting would drop the Copilot session and restart the
  // conversation on every reopen.
  const [isOpen, setIsOpen] = useState(false)
  const [isHidden, setIsHidden] = useState(true)

  const chatDivStyle: React.CSSProperties = {
    display: isHidden ? 'none' : 'inherit',
  }

  const handleOpenChat = () => {
    if (!isOpen) {
      setIsOpen(true)
    }
    setIsHidden(false)
  }

  const handleCloseChat = () => {
    setIsHidden(true)
  }

  return (
    <>
      {isHidden && (
        <svg
          viewBox="-12 -12 48 48"
          className="support-chat-svg"
          onClick={handleOpenChat}
          aria-label="Open support chat"
        >
          <circle cx="11" cy="11" r="20" fill="#0078d4" />
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      )}
      {isOpen && (
        <div className="support-chat-container" style={chatDivStyle}>
          <svg
            className="support-chat-close"
            viewBox="0 0 24 24"
            onClick={handleCloseChat}
            aria-label="Close support chat"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
          <iframe
            className="support-chat-iframe"
            src={EMBED_URL}
            title="Support chat"
          />
        </div>
      )}
    </>
  )
}

export default SupportChat
